export const publicRoutes = [
    '/auth',
    '/'
]